// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1aFNP","tab":"ProcedureTabs_tab__2csQ5"};